import Reveal from "@/components/feature/Reveal";
import SectionTitle from "@/components/feature/SectionTitle";
import { flowSteps } from "@/mocks/flow";

export default function Flow() {
  return (
    <section id="flow" className="bg-background-100 py-16 md:py-24">
      <div className="site-container">
        <Reveal>
          <SectionTitle
            upper="FLOW"
            under="お問い合わせからお支払いまで、できる限りシンプルに進めます。"
          >
            ご依頼の流れ
          </SectionTitle>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-5">
          {flowSteps.map((step, i) => (
            <Reveal key={step.title} delay={i * 60}>
              <div className="relative grid h-full grid-cols-[auto_1fr] items-start gap-x-3 gap-y-1.5 rounded-lg border border-background-200 bg-background-50 p-4 md:block">
                <span className="col-start-1 row-start-1 flex h-9 w-9 items-center justify-center">
                  <i className={`${step.icon} text-xl text-primary-600`} />
                </span>
                <p className="col-start-2 row-start-1 min-w-0 font-heading text-base font-black leading-snug text-foreground-950 md:mt-3">{step.title}</p>
                <p className="col-start-2 row-start-2 min-w-0 text-sm leading-relaxed text-foreground-600 md:mt-1.5">{step.text}</p>
                {i < flowSteps.length - 1 ? (
                  <i className="ri-arrow-right-line absolute -right-3.5 top-1/2 hidden -translate-y-1/2 text-lg text-primary-300 md:block" />
                ) : null}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}